import {IMAGE_URL} from "../../../app_url";

/** Referral-template picker. Selection and printing remain page-owned. */
export function ReferTemplateModal({
  isOpen,
  templates = [],
  selectedTemplateId,
  isSubmitting,
  onClose,
  onSelect,
  onPrint,
}) {
  if (!isOpen) return null;

  return (
    <div
      className="modal TemplateModal otherTemplateModal referTemplate"
      onClick={onClose}
    >
      <div className="modal-content" onClick={(event) => event.stopPropagation()}>
        <div className="modal-header">
          <button
            aria-label="Close referral templates"
            className="CloseButton"
            onClick={onClose}
            type="button"
          />
          <h3>Refer Templates</h3>
        </div>
        <div className="modal-body">
          <ul className="template-list">
            {templates.map((template, index) => (
              <li
                key={template?.id ?? `${template?.template_name}-${index}`}
                onClick={() => onSelect(template?.id)}
              >
                <div
                  className={`templateImg ${
                    selectedTemplateId === template?.id ? "selected" : ""
                  }`}
                >
                  <img
                    src={
                      template?.template_image_url ||
                      IMAGE_URL + template?.template_image
                    }
                    alt="Template image"
                  />
                </div>
                <h4>{template?.template_name}</h4>
              </li>
            ))}
          </ul>
          <ul className="template-list buttonSec">
            <li className="downloadBtnSec">
              <button
                className="downloadBtn"
                disabled={isSubmitting}
                onClick={onPrint}
                type="button"
              >
                {isSubmitting ? "Please wait..." : "Print"}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
